export default "__VITE_ASSET__pt8ULtL6__"